"use client";

import React from "react";

import { Spacer } from "../spacing";

import { Pill, Label, CloseButton } from "./styled";

export interface IProps {
  /** Label text to be displayed within the tag */
  label: string;
  /** Callback called when the tag is clicked */
  onClick?: () => void;
  /** Callback called when the close button is clicked */
  onClose?: () => void;
  "data-test-id"?: string;
}

/**
 * @trackcomponent
 */
export const SearchRecommendationPill: React.FC<IProps> = ({
  label,
  onClick,
  onClose,
  ["data-test-id"]: dataTestId,
}) => {
  return (
    <Pill onClick={onClick} data-test-id={dataTestId ?? label}>
      <Label>{label}</Label>
      {onClose ? (
        <>
          <Spacer size={4} />
          <CloseButton onClose={onClose} />
        </>
      ) : (
        <Spacer size="1x" />
      )}
    </Pill>
  );
};
